import React, { memo } from 'react';
import { Box, Paper, Typography, Skeleton, Tooltip } from '@mui/material';

const DEMO_DATA_TOOLTIP = 'Demo data for illustration';

const MiniKPICard = memo(({
  title,
  value,
  subtitle,
  color = '#005587',
  isLoading = false,
  isDemoData = false,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        borderRadius: '8px',
        padding: '8px 12px',
        backgroundColor: '#ffffff',
        border: '1px solid #e8eaed',
        borderLeft: `4px solid ${color}`,
        transition: 'box-shadow 0.2s',
        '&:hover': { boxShadow: '0 2px 12px rgba(0,0,0,0.08)' },
      }}
    >
      {isLoading ? (
        <Box>
          <Skeleton variant="text" width="60%" height={14} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="40%" height={30} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="70%" height={12} />
        </Box>
      ) : (
        <Box>
          <Tooltip title={isDemoData ? DEMO_DATA_TOOLTIP : ''} arrow disableHoverListener={!isDemoData}>
            <Typography sx={{
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 600,
              fontSize: '10px',
              color: '#5f6368',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              mb: 0.25,
              lineHeight: 1.1,
              cursor: isDemoData ? 'help' : 'default',
              width: 'fit-content',
            }}>
              {title}
              {isDemoData && (
                <Box
                  component="span"
                  sx={{ color: '#80868b', fontWeight: 700, ml: 0.25 }}
                >
                  *
                </Box>
              )}
            </Typography>
          </Tooltip>
          <Typography sx={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 700,
            fontSize: { xs: '16px', sm: '18px', md: '20px', lg: '22px' },
            color: '#202124',
            lineHeight: 1.0,
            mb: 0.25,
          }}>
            {value}
          </Typography>
          <Typography sx={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '10px',
            color: '#80868b',
            lineHeight: 1.3,
          }}>
            {subtitle}
          </Typography>
        </Box>
      )}
    </Paper>
  );
});

MiniKPICard.displayName = 'MiniKPICard';

export default MiniKPICard;
